module.exports = __webpack_public_path__ + "img/pay-icon-9.b5ad9d46.png";